// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import packageJson from '../../package.json';

export const environment = {
  // httpPort: 'https://rvsf-dev.api.tatamotors',//SANDBOX DEVELOPMENT
  httpPort: 'https://mobility-cv-dev-microservices.api.tatamotors',//QK DEVELOPMENT
  // httpPort: 'https://mobility-cv-prod-microservices.api.tatamotors',//PROD DEVELOPMENT
  // httpPort: 'http://localhost:8002',//LOCAL DEVELOPMENT — points at local SKIN, see HOW_IT_WORKS.md

  // locationPort : 'https://skindevreplica.api.tatamotors/api/v2/ecom/search/geo_dropdowns/',  //SANDBOX DEVELOPMENT
  locationPort : ' https://digital-edukaan-cv-dev-ms.api.tatamotors/api/v2/ecom/search/geo_dropdowns/',
  // freeSearchPort : 'https://skindevreplica.api.tatamotors/api/v1/ecom/',  //SANDBOX DEVELOPMENT
  freeSearchPort : 'https://digital-edukaan-cv-dev-ms.api.tatamotors/api/v1/ecom/FreeSearchTokenRequest/',  //SANDBOX DEVELOPMENT


  "rewire_sugar": "8x/A?D(G+KbPeShVkYp3s6v9y$B&E)H@",//SANDBOX DEVELOPMENT
  "rewire_salt": "v8y/B?E(H+MbQeTh",//SANDBOX DEVELOPMENT

  // "rewire_sugar": "w9z$C&E)H@McQfTjWnZr4u7x!A%D*G-J", //PROD DEVELOPMENT
  // "rewire_salt": "6v9y$B&E)H@McQfT", //PROD DEVELOPMENT

  // locationPort : 'https://skinprod.api.tatamotors/api/v2/ecom/search/geo_dropdowns/',  //PROD DEVELOPMENT
  // freeSearchPort : 'https://skinprod.api.tatamotors/api/v1/ecom/',   //PROD DEVELOPMENT
  apiVersion: '/api/v1/rvsf/',
  version: packageJson.version,
  production: false,
  // Used by server.ts for CSP/CORS/Permissions-Policy headers. Was missing
  // here previously while server.ts hardcoded an import of environment.prod
  // instead of the fileReplacements-swapped environment -- meaning this
  // value was never actually reachable in a dev/SSR-dev-server run.
  baseUrl: 'http://localhost:4000/',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.